var utils = require('../lib/utils');

module.exports = utils.wrapAEventElement('a-load', 'load');
